import Button from 'components/Forms/Button/Button';
import { mapAddToCartPopupData } from 'connectors/cart/Cart';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { useAddToCart } from 'hooks/cart/useAddToCart';
import { createPersooEventForAddToCart } from 'modules/persoo/persooEvents';
import useTranslation from 'next-translate/useTranslation';
import { AddToCartBasketSmallIcon, SpinnerIcon } from 'public/svg/IconsSvg';
import { usePersistStore } from 'store/usePersistStore';
import { GtmListNameType, GtmMessageOriginType } from 'types/gtm';

type AddToCartProps = {
    productUuid: string;
    gtmListName: GtmListNameType;
    listIndex: number;
    isBookingOnly: boolean;
    quantity: number;
    onAddToCart?: (productUuid: string) => void;
};

const AddToCart: FC<AddToCartProps> = ({
    productUuid,
    gtmListName,
    listIndex,
    isBookingOnly,
    quantity,
    onAddToCart,
}) => {
    const testIdentifier = 'blocks-product-addtocart';
    const { t } = useTranslation();
    const [changeCartItemQuantity, fetching] = useAddToCart(GtmMessageOriginType.product, gtmListName);
    const { currencyCode } = useDomainConfig();
    const { updateUserState } = usePersistStore((s) => s);

    const onAddToCartHandler = async () => {
        const addToCartResult = await changeCartItemQuantity(productUuid, listIndex, quantity, gtmListName);
        const mappedAddToCartResult = mapAddToCartPopupData(addToCartResult, currencyCode);

        if (mappedAddToCartResult) {
            if (onAddToCart) {
                onAddToCart(productUuid);
            }

            createPersooEventForAddToCart(mappedAddToCartResult.catalogNumber);
            updateUserState({
                addToCartPopupData: {
                    gtmListName,
                    listIndex,
                    product: mappedAddToCartResult,
                },
            });
        }
    };

    return (
        <Button
            data-testid={testIdentifier}
            name="add-to-cart"
            size="smallNarrow"
            type="button"
            onClick={onAddToCartHandler}
        >
            {isBookingOnly ? (
                t('Book')
            ) : (
                <>
                    {fetching ? <SpinnerIcon /> : <AddToCartBasketSmallIcon className="h-4 w-4" />}
                    {t('Add to cart')}
                </>
            )}
        </Button>
    );
};

export default AddToCart;
